import {CheckIcon} from '@primer/octicons-react'
import {ActionList} from '@primer/react'

import {type UserSetting, useUserSettings} from '../user-settings'

export const RoadmapUserSettingsMenu = () => {
  const {roadmapTruncateTitles, roadmapShowDateFields} = useUserSettings()

  return (
    <>
      <OptionsElement option={roadmapTruncateTitles} />
      <OptionsElement option={roadmapShowDateFields} />
    </>
  )
}

export function OptionsElement({option}: {option: UserSetting}) {
  return (
    <ActionList.Item key={option.name} onSelect={option.toggleEnabled}>
      <ActionList.LeadingVisual>{option.enabled && <CheckIcon />}</ActionList.LeadingVisual>
      {option.label}
    </ActionList.Item>
  )
}

try{ RoadmapUserSettingsMenu.displayName ||= 'RoadmapUserSettingsMenu' } catch {}
try{ OptionsElement.displayName ||= 'OptionsElement' } catch {}